import { ReactNode } from 'react';

/**
 * Full-viewport LOX-branded backdrop for the public (unauthenticated) screens.
 *
 * Deep navy base (ox-ink tones) with an electric-blue ellipse glow and a
 * royal-blue circle glow. On small screens (< 768px) an extra dark blob and a
 * bottom fade soften the composition behind the headings.
 */
const LayoutBackground = ({ children }: { children: ReactNode }) => {
  return (
    <div className="relative h-screen w-screen overflow-hidden bg-primary-950">
      {/* Electric-blue ellipse glow */}
      <div
        aria-hidden
        className="absolute left-[55%] top-[-46%] h-[774px] w-[600px] rotate-[42.3deg] bg-ox-blue opacity-60 blur-[192px] max-md:left-[64px] max-md:top-[75%] max-md:rotate-[132.3deg]"
      />
      {/* Royal-blue circle glow */}
      <div
        aria-hidden
        className="absolute left-[22%] top-[33%] size-[164px] bg-ox-royal opacity-50 blur-[100px] max-md:left-[-30px] max-md:top-[-66px]"
      />
      {/* Small screens only: dark blob + bottom fade behind the headings */}
      <div
        aria-hidden
        className="absolute top-[15%] hidden h-[96px] w-[394px] -scale-x-100 bg-primary-950 blur-[32px] max-md:block"
      />
      <div
        aria-hidden
        className="absolute top-[25%] hidden h-[132px] w-screen bg-linear-to-b from-primary-950/0 to-primary-950 max-md:block"
      />
      {children}
    </div>
  );
};

export default LayoutBackground;
